import { maskCardNumber, useInformation } from "@usher/pe-client-front-end-lib"
import exchangeIcon from "@/Images/cards_images/exchange.svg"

export const Information = ({ isCreate }: { isCreate?: boolean }) => {
  const { fee, card, cryptoPrice, crypto, cryptoAmount, deposit, fiat } = useInformation()
  return (
    <div className="col-md-6">
      <div
        className="octagon octagon-whit block-table-octagon buy-steps__info"
        style={{ display: "block" }}
      >
        <h3 className="buy-steps__caption">Information</h3>
        <div className="buy-steps__change-info">
          <span className="buy-steps__from">
            {isCreate ? cryptoPrice : cryptoAmount}{" "}
            <span className="buy-steps__name">{crypto}</span>
          </span>
          <img src={exchangeIcon} alt="" className="buy-steps__exchange-ic" />
          <span className="buy-steps__to">
            {deposit} <span className="buy-steps__name">{fiat}</span>
          </span>
        </div>
        <div className="buy-steps__info-full">
          {!isCreate && (
            <div className="buy-steps__info-row">
              <span className="buy-steps__info-rate">To card</span>
              <span className="buy-steps__info-val">{maskCardNumber(card?.card_pan)}</span>
            </div>
          )}
          <div className="buy-steps__info-row">
            <span className="buy-steps__info-rate">Amount of transfer</span>
            <span className="buy-steps__info-val">
              {cryptoPrice} {crypto}
            </span>
          </div>
          {!isCreate && (
            <div className="buy-steps__info-row">
              <span className="buy-steps__info-rate">Fee</span>
              <span className="buy-steps__info-val">
                {fee} {crypto}
              </span>
            </div>
          )}
          {!isCreate && (
            <div className="buy-steps__info-row">
              <span className="buy-steps__info-rate">Total amount </span>
              <span className="buy-steps__info-val">
                {cryptoAmount} {crypto}
              </span>
            </div>
          )}
          <div className="buy-steps__info-row">
            <span className="buy-steps__info-rate">
              {isCreate ? "Amount for card issue" : "Amount to be credited"}
            </span>
            <span className="buy-steps__info-val">
              {deposit} {fiat}
            </span>
          </div>
        </div>
      </div>
    </div>
  )
}
